import React from 'react';
import image from '../../../Assets/Backgrounds/bitsHubBg.webp';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
const Banner=()=>{
    return(
        <>
        <SharedBanner 
        title="The User Testing Field Guide"
        backgroundImage={image}
        styles="noshade"
        />
        </>
    )
}
export default Banner ;

